import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import { Stack } from '@mui/material';
import { addLeadingZeros } from 'commons/utils';
import { CustomDialog } from '../Dialog';
import { IModal } from './@types';
import * as S from './styles';

export const ApproveModal = ({ isOpen, iconButton, onClose, order, callback = () => {}, type }: IModal) => {
  const text = type;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await callback();
    } finally {
      setIsSubmitting(false);
    }
  };

  const itemsModal = [
    { label: 'Número do pedido', value: addLeadingZeros(order.id, 6) },
    { label: 'Pedido feito em', value: order.orderDate },
    { label: 'Conteúdo', value: order.content },
  ];

  return (
    <CustomDialog
      isOpen={isOpen}
      onClose={onClose}
      title={
        <S.Title>
          Deseja <S.TitleWordStrong type={type}>{text}</S.TitleWordStrong> a solicitação?
        </S.Title>
      }
      description={
        <Stack gap={1.5}>
          {itemsModal.map((item, index) => (
            <Stack key={index} direction="row" gap={2}>
              <S.Label>{item.label}</S.Label>
              <S.Value>{item.value}</S.Value>
            </Stack>
          ))}
          {order.items.map(item => {
            const subItems = [
              { label: 'Roteiro', value: !item.script ? 'Sem Roteiro' : addLeadingZeros(item.script) },
              { label: 'Data de gravação', value: item.recordingDate },
              { label: 'Agência', value: item.agency.name },
              { label: item.type.toLowerCase().includes('fiscal') ? 'Tipo de Fiscal' : 'Tipo de Figurante', value: item.type },
              { label: 'Quantidade', value: item.amount },
              { label: 'Valor unitário', value: item.unitCost },
              { label: 'Valor Total', value: item.totalCosts },
            ];
            return (
              <Stack paddingY={1.5} key={uuid()} gap={1.5}>
                {subItems.map(item => (
                  <Stack key={uuid()} direction="row" gap={2}>
                    <S.Label>{item.label}</S.Label>
                    <S.Value>{item.value}</S.Value>
                  </Stack>
                ))}
              </Stack>
            );
          })}
        </Stack>
      }
      actions={[
        {
          testId: 'button-cancel',
          label: 'Cancelar',
          onClick: onClose,
          disabled: isSubmitting,
        },
        {
          testId: 'button-submit',
          label: `${text} Solicitação`,
          onClick: onSubmit,
          disabled: isSubmitting,
          variant: 'outlined',
          iconButton,
        },
      ]}
    ></CustomDialog>
  );
};
